

























































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {Component} from "vue-property-decorator";
import {createGroups, verificationGroups} from "@/modules/account/service";
import {AuthStore} from "@/modules/auth/store";

const form = {
    username: "",
    sender: "",
    senderPhone: "",
    password: "",
    email: "",
    // verificationCode: "",
}
@Component({
    name: "CreateMember"
})
export default class extends mixins(CommonMixin){
    isSubmitting = false;
    form = { ...form };
    rules = {
        username: [{ required: true, message: 'Nhập tên đăng nhập', trigger: "change" }],
        senderPhone: [{ required: true, message: 'Nhập số điện thoại', trigger: "change" }],
        password: [
            { required: true, message: 'Nhập mật khẩu', trigger: "change" },
            { min: 6, message: 'Mật khẩu ít nhất 6 kí tự', trigger: 'change' }
        ],
        email: [{ required: true, message: 'Nhập email', trigger: "change" }],
        sender: [{ required: true, message: 'Nhập họ tên', trigger: "change" }],
        // verificationCode: [{ required: true, message: 'Nhập mã xác nhận', trigger: "change" }]
    }

    prefixUsername = AuthStore.user?.customer?.customerCode + '-'

    async createMember() {
        try {
            await createGroups(this.form);
            this.$message.success("Tạo thành viên thành công");
            this.$router.push({ name: "member" });
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
    }

    async verificationGroups() {
        if (!this.form.email) {
            this.$message.error("Nhập email");
            return;
        }
        try {
            await verificationGroups({ email: this.form.email });
            this.$message.success("Đã gửi mã xác nhận đến email của bạn");
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Đã xảy ra lỗi");
        }
    }
}
